// openEHR RM model — BMM package org.openehr.rm.data_structures.representation
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { LOCATABLE } from "../common/archetyped.ts";
import type { DATA_VALUE } from "../data_types/basic.ts";
import type { DV_CODED_TEXT, DV_TEXT } from "../data_types/text.ts";
import * as openehr_base from "../../base/mod.ts";
import { applyRmInit, type RmInit } from "../../base/apply_rm_init.ts";

/**
 * The abstract parent of \`CLUSTER\` and \`ELEMENT\` representation classes.
 */
export abstract class ITEM extends LOCATABLE {
}

/**
 * The grouping variant of \`ITEM\`, which may contain further instances of \`ITEM\`, in an ordered list.
 */
export class CLUSTER extends ITEM {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

  /**
   * Ordered list of items - \`CLUSTER\` or \`ELEMENT\` objects - under this \`CLUSTER\`.
   */
  items?: ITEM[];
}

/**
 * The leaf variant of \`ITEM\`, to which a \`DATA_VALUE\` instance is attached.
 */
export class ELEMENT extends ITEM {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

  /**
   * Flavour of null value, e.g. \`253|unknown|\`, \`271|no information|\`, \`272|masked|\`, and \`273|not applicable|\`.
   */
  null_flavour?: DV_CODED_TEXT;
  /**
   * Property representing leaf value object of \`ELEMENT\`. In real data, any concrete subtype of \`DATA_VALUE\` can be used.
   */
  value?: DATA_VALUE;
  /**
   * Optional specific reason for null value; if set, \`_null_flavour_\` must be set. Null reason may apply only to a minority of clinical data, commonly needed in reporting contexts.
   */
  null_reason?: DV_TEXT;
  /**
   * True if value logically not known, e.g. if indeterminate, not asked etc.
   * @returns Result value
   */
  is_null(): openehr_base.Boolean {
    // Inv_is_null_valid: is_null() = (value = Void). null_flavour is separate.
    return openehr_base.Boolean.from(
      this.value === undefined || this.value === null,
    );
  }
}
